import IWallMetaData from 'components/interfaces/IWallMetaData';

import { SET_WALL_META_DATA, SET_WALLS_META_DATA } from './types';

const initialState: IWallMetaData[] = [];

export default (
  state: IWallMetaData[] = initialState,
  action: {
    type: string;
    wallMetaData?: IWallMetaData;
    wallsMetaData?: IWallMetaData[];
  }
): IWallMetaData[] => {
  if (action.type === SET_WALL_META_DATA) {
    if (action.wallMetaData === undefined) {
      return state;
    }

    const existingWallMetaData = state.find(
      (current) => current.identifier === action.wallMetaData?.identifier
    );

    if (existingWallMetaData === undefined) {
      return [...state, action.wallMetaData];
    }

    return state.map((current) =>
      current.identifier === action.wallMetaData?.identifier
        ? action.wallMetaData
        : current
    );
  }

  if (action.type === SET_WALLS_META_DATA) {
    if (action.wallsMetaData === undefined) {
      return state;
    }

    return action.wallsMetaData;
  }

  return state;
};
